import React from "react";
import {isDarkMode} from "../utils/DOMUtils";
import useLocalStorage from "../hooks/useLocalStorage";

/**
 * HOC (Higher-Order Component), który wstrzykuje isDarkMode do propsów
 * na podstawie localStorage i bieżącego DOM-owego trybu.
 */
export default function withDarkMode(WrappedComponent) {
    return function DarkModeWrapper(props) {
        useLocalStorage("theme", "", {
            isPrivate: true,
            sync: true,
        });

        return <WrappedComponent {...props} isDarkMode={isDarkMode()} />;
    };
}
